import { ReportChart } from "./ReportChart";
export default ReportChart;
